// Invitation and password-recovery emails from Netlify Identity link to the
// site with a one-time token in the URL fragment. Take it out of the address
// bar at once and keep it in memory only, until the set-password page hands
// it to the server. It is never stored and never logged.
let captured = null;

const PATTERN = /^#(invite|recovery)_token=([A-Za-z0-9_-]+)$/;

export function captureLinkToken() {
  const match = PATTERN.exec(window.location.hash || '');
  if (!match) return false;
  captured = { kind: match[1], token: match[2] };
  window.history.replaceState(null, '', window.location.pathname);
  return true;
}

export function takeLinkToken() {
  const value = captured;
  captured = null;
  return value;
}

export function hasLinkToken() {
  return captured !== null;
}
